import React from 'react';
import Router from 'next/router';
import { ToastContainer } from 'react-toastify';
import { WAIT_FOR_ACTION, ERROR_ACTION } from 'redux-wait-for-action';
import App, { Container } from 'next/app';
import { ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux';
import withReduxSaga from 'next-redux-saga';
import { setCookie } from 'nookies';
import NProgress from 'nprogress';
import { SizesProvider } from 'react-sizes';
import GlobalStyle from '../styles/globalStyle';
import { withReduxStore } from '../HOC';
import theme from '../styles/theme';
import { getWindowSize } from "../utils";
import { updateUserSession, checkPromoCode, openModal } from '../redux/actions';
import { FETCH_USER_SUCCESS, FETCH_USER_FAILURE, CHECK_PROMO_CODE_SUCCESS, CHECK_PROMO_CODE_FAILURE } from '../redux/types';
import sentry from '../utils/sentry'
import Cookie from 'js-cookie';

const { captureException } = sentry();
const releaseVersion = process.env.APP_VERSION || 'none';

// eslint-disable-next-line no-console
console.log(`Running dayaxe-web ${releaseVersion}`);

Router.events.on('routeChangeStart', () => NProgress.start());

Router.events.on('routeChangeComplete', url => {
  NProgress.done();

  if (typeof window.analytics !== 'undefined') {
    setTimeout(() => {
      if (url.includes('/l/')) {
        window.analytics.page('Listing', {
          name: document.title,
        })
      } else if (url.includes('/checkout/')) {
        window.analytics.page('Checkout', {
          name: document.title,
        })
      } else if (url.includes('/purchase/')) {
        window.analytics.page('Purchase', {
          name: document.title,
        })
      } else if (url.includes('/s/')) {
        window.analytics.page('Search', {
          name: document.title,
        })
      } else if (url === '/') {
        window.analytics.page('Home', {
          name: document.title,
        })
      }
    }, 0);
  }
});

Router.events.on('routeChangeError', () => NProgress.done());

@withReduxStore
@withReduxSaga
class Dayaxe extends App {
  oldy = 0;
  static async getInitialProps({ Component, ctx }) {
    const { reduxStore, req } = ctx;
    const { dispatch } = reduxStore;

    let pageProps = {};
    let userAgent;

    if (req) {
      userAgent = ctx.req.headers['user-agent'];

      if (req.query.promo) {
        const { promo } = req.query;

        await dispatch({
          ...checkPromoCode(promo),
          [ERROR_ACTION]: CHECK_PROMO_CODE_FAILURE,
          [WAIT_FOR_ACTION]: CHECK_PROMO_CODE_SUCCESS
        }).catch(err => err);
      }

      await dispatch({
        ...updateUserSession(ctx),
        [ERROR_ACTION]: FETCH_USER_FAILURE,
        [WAIT_FOR_ACTION]: FETCH_USER_SUCCESS,
      })
        .then(() => {
          setCookie(ctx, 'signedIn', 'true', { path: '/' });
        })
        .catch(err => err);
    } else {
      userAgent = navigator.userAgent;
    }

    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx);
    }

    const windowSize = getWindowSize(userAgent);

    return { pageProps, windowSize };
  }

  componentDidCatch(error, errorInfo) {
    captureException(error, { errorInfo });
  }

  componentDidMount() {
    Router.beforePopState(({ as }) => {
      // eslint-disable-next-line
      location.href = as;
    });

    if (typeof window.analytics !== 'undefined') {
      if (window.location.pathname === '/') {
        window.analytics.page("Home", {
          name: document.title,
        })
      }
    }


  //   const { dispatch } = this.props.reduxStore;
    
  //   dispatch({
  //     ...openModal("activeCampaign")
  //   })
  }

  componentWillUnmount() {
    window.removeEventListener('mouseout', this.mouseout.bind(this));
  }

  mouseout = (e) => {
    e.preventDefault();
    e = e ? e : window.event;
    let from = e.relatedTarget || e.toElement;
    const seenPopup = Cookie.get('campaignPopup');

    if ((!from || from.nodeName == "HTML") && (e.pageY < this.oldy) && !seenPopup) {
      this.oldy = e.pageY

      // var date = new Date();
      // var minutes = 0.1;
      // date.setTime(date.getTime() + (minutes * 60 * 1000));
      Cookie.set('campaignPopup', true, { expires: 1 });

      const { dispatch } = this.props.reduxStore;
    
      dispatch({
        ...openModal("activeCampaign")
      })
    
    } else {
      this.oldy = e.pageY
    }
  }

  render() {
    const { Component, pageProps, reduxStore, windowSize } = this.props;

    return (
      <Container>
        <Provider store={reduxStore}>
          <GlobalStyle />
          <ThemeProvider theme={theme}>
            <SizesProvider config={windowSize}>
              <ToastContainer closeButton={false} />
              <Component {...pageProps} />
            </SizesProvider>
          </ThemeProvider>
        </Provider>
      </Container>
    )
  }
}

export default Dayaxe;
